import noData from '../img/no-data.png'
function Nodata () {
    return (
        <div className='g-nodata'>
            <img src={noData} />
            <p>
                暂无数据
            </p>
        </div>
    )
}
export default Nodata